// ═══════════════════════════════════════════════════════════════
// Breadcrumbs — lightweight navigation trail
// Usage: <Breadcrumbs items={[{ label: 'PA Grants', to: '/pagrants/pa' }, { label: 'Projects' }]} />
// ═══════════════════════════════════════════════════════════════

import { useNavigate } from 'react-router-dom';
import { Group, Text } from '@mantine/core';
import { IconChevronRight } from '@tabler/icons-react';

export interface BreadcrumbItem {
  label: string;
  to?: string;
}

export default function Breadcrumbs({ items }: { items: BreadcrumbItem[] }) {
  const navigate = useNavigate();

  return (
    <Group gap={4} mb="sm" style={{ flexWrap: 'wrap' }}>
      {items.map((item, i) => {
        const isLast = i === items.length - 1;
        return (
          <Group key={i} gap={4}>
            {i > 0 && <IconChevronRight size={12} color="#adb5bd" />}
            {item.to && !isLast ? (
              <Text
                size="xs"
                c="blue"
                fw={500}
                style={{ cursor: 'pointer' }}
                onClick={() => navigate(item.to!)}
              >
                {item.label}
              </Text>
            ) : (
              <Text size="xs" c={isLast ? 'dark' : 'dimmed'} fw={isLast ? 600 : 400}>
                {item.label}
              </Text>
            )}
          </Group>
        );
      })}
    </Group>
  );
}
